import { render } from "./NoDealsPlaceholder.vue?vue&type=template&id=7ff1e124&scoped=true&ts=true"
import script from "./NoDealsPlaceholder.vue?vue&type=script&lang=ts"
export * from "./NoDealsPlaceholder.vue?vue&type=script&lang=ts"

import "./NoDealsPlaceholder.vue?vue&type=style&index=0&id=7ff1e124&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff1e124"]])

export default __exports__